import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
import React from 'react';
import { colors } from '../theme/colors';
export default function WaitingIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
      fill: colors.buttonForeground
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5 22.6562C18.1091 22.6562 22.6562 18.1091 22.6562 12.5C22.6562 6.89086 18.1091 2.34375 12.5 2.34375C6.89086 2.34375 2.34375 6.89086 2.34375 12.5C2.34375 18.1091 6.89086 22.6562 12.5 22.6562Z",
      fill: "#BDBDBD"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.0469 12.5C14.0469 13.3551 13.3551 14.0469 12.5 14.0469C11.6449 14.0469 10.9531 13.3551 10.9531 12.5C10.9531 11.6449 11.6449 10.9531 12.5 10.9531C13.3551 10.9531 14.0469 11.6449 14.0469 12.5ZM16.2812 10.9531C15.4262 10.9531 14.7344 11.6449 14.7344 12.5C14.7344 13.3551 15.4262 14.0469 16.2812 14.0469C17.1363 14.0469 17.8281 13.3551 17.8281 12.5C17.8281 11.6449 17.1363 10.9531 16.2812 10.9531ZM8.71875 10.9531C7.86367 10.9531 7.17188 11.6449 7.17188 12.5C7.17188 13.3551 7.86367 14.0469 8.71875 14.0469C9.57383 14.0469 10.2656 13.3551 10.2656 12.5C10.2656 11.6449 9.57383 10.9531 8.71875 10.9531Z",
      fill: "white"
    })]
  });
}